export const innerPath = (childRoute: string, parentRoute: string) => {
  return parentRoute + childRoute;
};
